import React from "react";
import clsx from "clsx";

class BookingButtonPresenterMenu extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		var tabClasses = clsx({
			'active': this.props.active_tab == 'menu',
			'tab-pane': true,
		})

		return (
			<div className={tabClasses} id="menu">
				<div className="row" style={{marginBottom: '-15px'}}>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('vouchers_menu_visible')}</label>
              <br />
              {this.props.vouchers_menu_visible ? I18n.t('yes') : I18n.t('no')}
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('vouchers_menu_label')}</label>
              <br />
              {this.props.vouchers_menu_label}
            </div>
          </div>
        </div>
        <div className="row" style={{marginBottom: '-15px'}}>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('daily_rentals_menu_visible')}</label>
              <br />
              {this.props.daily_rentals_menu_visible ? I18n.t('yes') : I18n.t('no')}
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('daily_rentals_menu_label')}</label>
              <br />
              {this.props.daily_rentals_menu_label}
            </div>
          </div>
        </div>
          {/* 
          
          Leaving this commented out for now since we might bring it back later 
          
          */}
          {/* <div className="col-md-2">
            <div className="form-group">
              <label>{I18n.t('products_menu_visible')}</label>
              <br />
              {this.props.products_menu_visible ? I18n.t('yes') : I18n.t('no')}
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('products_menu_label')}</label>
              <br />
              {this.props.products_menu_label}
            </div>
          </div> */}
     
			</div>
		);
	}

}

export default BookingButtonPresenterMenu
